import { SOCIAL_TACTICS, Strategy as StrategyType } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ProviderIcon } from 'screens/Calendar/WeekViewV2/CalendarEventCard/Icon'
import { Button } from 'blaze-ui/Button'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { BrandPlanTactic } from 'types'
import { TACTIC_TO_PROVIDER } from 'screens/blaze/Home/VirtualMarketerHome/Brain/PlatformSection/Types'
import { Key, useEffect, useState } from 'react'

export interface StrategyOrganicDropdownProps {
  strategy: StrategyType
  onUpdate: (strategy: StrategyType) => void
  isDisabled?: boolean
}

export const StrategyOrganicDropdown = ({ strategy, onUpdate, isDisabled }: StrategyOrganicDropdownProps) => {
  const [tactics, setTactics] = useState<BrandPlanTactic[]>(
    strategy.tactics.filter((tactic) => SOCIAL_TACTICS.includes(tactic)),
  )

  useEffect(() => {
    setTactics(strategy.tactics.filter((tactic) => SOCIAL_TACTICS.includes(tactic)))
  }, [strategy.tactics])

  return (
    <MenuTrigger placement="bottom-end" popoverClassName={Styles.popover}>
      <Button variant="secondary" withChevron="down" className={Styles.channelsButton} isDisabled={isDisabled}>
        {(tactics.length > 0 ? tactics : SOCIAL_TACTICS).map((tactic) => (
          <ProviderIcon
            key={tactic}
            provider={TACTIC_TO_PROVIDER.find((t) => t.tactic === tactic)?.provider as ExternalIntegrationEnum}
            size={16}
            isHovered={false}
            zIndex={0}
            borderColor="rgba(247, 247, 247, 1)"
            marginLeft={0}
          />
        ))}
      </Button>
      <Menu
        aria-label="Menu"
        onAction={(key: Key) => {
          const newTactic = key as BrandPlanTactic

          if (tactics.includes(newTactic) && tactics.length === 1) {
            return
          }

          const newTactics = strategy.tactics.includes(newTactic)
            ? strategy.tactics.filter((tactic) => tactic !== newTactic) // Remove the tactic if it's already selected
            : [...strategy.tactics, newTactic] // Add the tactic if it's not already selected

          setTactics(newTactics.filter((tactic) => SOCIAL_TACTICS.includes(tactic)))
          onUpdate({
            ...strategy,
            tactics: newTactics,
          })
        }}
        showCheckmark
        selectionMode="multiple"
        selectedKeys={new Set(tactics)}
        disabledKeys={tactics.length === 1 ? [tactics[0]] : undefined}
      >
        <Item key="instagram" textValue="Instagram" data-close-on-select={false}>
          <ProviderIcon provider={ExternalIntegrationEnum.Instagram} size={16} isHovered={false} marginLeft={0} />
          Instagram
        </Item>
        <Item key="facebook" textValue="Facebook" data-close-on-select={false}>
          <ProviderIcon provider={ExternalIntegrationEnum.Facebook} size={16} marginLeft={0} />
          Facebook
        </Item>
        <Item key="linkedin" textValue="LinkedIn" data-close-on-select={false}>
          <ProviderIcon provider={ExternalIntegrationEnum.LinkedIn} size={16} marginLeft={0} />
          LinkedIn
        </Item>
        <Item key="twitter" textValue="X" data-close-on-select={false}>
          <ProviderIcon provider={ExternalIntegrationEnum.X} size={16} marginLeft={0} />X
        </Item>
      </Menu>
    </MenuTrigger>
  )
}
